import React from 'react';

import { cn, useForeignPrice } from 'shared/lib';

type PriceWithForeignProps = {
  krw: number | null | undefined;
  // 보증금/월세처럼 두 KRW 금액을 한 줄에 함께 변환 표시할 때. 보통 block 모드와 함께 사용.
  krwSecondary?: number | null;
  // 단위 suffix (예: '/ month'). 단일 모드면 primary, pair 모드면 secondary 뒤에 붙음.
  suffix?: string;
  // true면 새 줄(display: block), false면 inline (기본).
  block?: boolean;
  className?: string;
};

/**
 * KRW 금액 옆/아래에 선택 통화의 환산값을 부기.
 * 외화 표시 안 함(KRW 선택)이거나 환율 없음일 땐 아무것도 렌더 안 함.
 *
 * 항상 <span>으로 렌더 (block일 땐 display: block) → <p>, <h1> 등 phrasing 컨테이너 안에서도 안전.
 */
const PriceWithForeign = ({ krw, krwSecondary, suffix, block, className }: PriceWithForeignProps) => {
  const primary = useForeignPrice(krw);
  const secondary = useForeignPrice(krwSecondary ?? null);

  const showPair = krwSecondary != null;

  if (showPair) {
    if (!primary && !secondary) return null;
  } else if (!primary) {
    return null;
  }

  let text: string;
  if (showPair) {
    const secondaryWithSuffix = suffix ? `${secondary ?? '-'} ${suffix.trim()}` : (secondary ?? '-');
    text = `≈ ${primary ?? '-'} / ${secondaryWithSuffix}`;
  } else {
    text = suffix ? `≈ ${primary} ${suffix.trim()}` : `≈ ${primary}`;
  }

  if (block) {
    return <span className={cn('mt-1 block text-xs font-normal text-gray-40', className)}>{text}</span>;
  }

  return <span className={cn('ml-1 whitespace-nowrap text-xs font-normal text-gray-40', className)}>{text}</span>;
};

export default PriceWithForeign;
